(function(){


function initWallPreviewTouch(){



const canvas =
document.querySelector(
".wall-canvas"
);



if(!canvas){

return;

}





const sceneKeys =
Object.keys(
window.AI_WALL_CONFIG?.scenes || {}
);



let currentSceneIndex = 0;





function changeScene(direction){



currentSceneIndex += direction;



if(
currentSceneIndex < 0
){

currentSceneIndex =
sceneKeys.length - 1;

}



if(
currentSceneIndex >= sceneKeys.length
){

currentSceneIndex = 0;

}





const sceneName =
sceneKeys[currentSceneIndex];





if(
window.WALL_PREVIEW_APPLY_SCENE
){


window.WALL_PREVIEW_APPLY_SCENE(
sceneName
);


}



}









// ================================
// Desktop arrows
// ================================


const prev =
document.getElementById(
"scene-prev"
);



const next =
document.getElementById(
"scene-next"
);





if(prev){


prev.addEventListener(
"click",
function(){

changeScene(-1);

});

}




if(next){


next.addEventListener(
"click",
function(){

changeScene(1);

});

}









// ================================
// Mobile Swipe
// ================================


let startX = 0;



canvas.addEventListener(
"touchstart",
function(e){


startX =
e.touches[0].clientX;


},
{
passive:true
}

);






canvas.addEventListener(
"touchend",
function(e){


const endX =
e.changedTouches[0].clientX;



const distance =
endX-startX;



if(
Math.abs(distance)<50
){

return;

}





if(distance < 0){


changeScene(1);


}else{


changeScene(-1);


}



},
{
passive:true
}

);




}



if(
document.readyState==="loading"
){

document.addEventListener(
"DOMContentLoaded",
initWallPreviewTouch
);


}else{


initWallPreviewTouch();


}



})();